module.exports = __webpack_public_path__ + "img/56.f5a756d4.jpg";